import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { map, take, takeUntil } from 'rxjs/operators';
import { NavigationStart, Router, ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-supporting-documents',
  templateUrl: './supporting-documents.component.html',
  styleUrls: ['./supporting-documents.component.scss']
})
export class SupportingDocumentsComponent implements OnInit {
  message;
  redirect_url;
  applicationType;
  unsubscribe$: Subject<boolean> = new Subject();
  constructor(private router: Router) {
    this.message = window.localStorage.getItem('message');
    this.applicationType = window.localStorage.getItem('application_type');
    this.redirect_url = window.localStorage.getItem('redirect_url');
    this.redirect_params = window.localStorage.getItem('redirect_params') ? JSON.parse(window.localStorage.getItem('redirect_params')) : null;
  }

  ngOnInit(): void {
    console.log('doc here')
    this.router.events.pipe(takeUntil(this.unsubscribe$)).subscribe((event) => {
      if (
        event instanceof NavigationStart &&
        event.url != `/contractor/company/supporting-document`
      ) {
        localStorage.removeItem('message');
        localStorage.removeItem('application_type');
        localStorage.removeItem('redirect_url');
      }
    });
  }


  redirectToExternalUrl() {
    // Build the URL with query parameters
    const urlWithParams = this.buildUrlWithParams(this.redirect_url, this.redirect_params);

    // Redirect to the external URL
    window.location.href = urlWithParams;
  }
  redirect_params(redirect_url: any, redirect_params: any) {
    throw new Error('Method not implemented.');
  }

  private buildUrlWithParams(url: string, params: { [key: string]: any }): string {
    const queryParams = Object.keys(params)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
      .join('&');

    return queryParams ? `${url}?${queryParams}` : url;
  }

}
